import React, { useState } from 'react'
import { Box, Typography } from '@mui/material'

import ImageModal from '../../../components/image_modal/ImageModal'
import { useImageGallery } from '../../forms/surveys/hooks/useImageGallery'
import { TASK_TYPES } from '../../constants/constants'
import { PlanimetryPhotoPanels } from './PlanimetryPhotoPanels'
import { UI_COLOR_TEXT_BODY_DARK, UI_COLOR_TEXT_SUMMARY_LABEL } from '../../../constants/uiColors'
import { renderBooleanChip } from './posTaskReportShared'

const REPORT_FIELD_LABEL_SX = {
  fontSize: 14,
  fontWeight: 800,
  color: UI_COLOR_TEXT_SUMMARY_LABEL,
  whiteSpace: 'nowrap'
}

const REPORT_FIELD_VALUE_SX = {
  fontSize: 14,
  color: UI_COLOR_TEXT_BODY_DARK,
  wordBreak: 'break-word'
}

export default function PosTaskPlanimetryReport({ activity }) {
  const [showImageUrl, setShowImageUrl] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
  const {
    imageGallery,
    isImageGalleryReady,
    showImage,
    currentImageShow,
    filenameForDownloads,
    handleShowImage,
    handleImageClick
  } = useImageGallery(activity?.planimetry_images, activity?.uid, 1, TASK_TYPES.planimetry.key)

  const referenceImageUrl = activity?.task_data?.image_url
  const isFulfilled = Boolean(activity?.planimetry_fulfilled)

  const handleUrlImage = (url) => {
    setImageUrl(url)
    setShowImageUrl(true)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
        <Typography sx={REPORT_FIELD_LABEL_SX}>¿Cumple planimetría?:</Typography>
        {renderBooleanChip(isFulfilled)}
      </Box>

      {!isFulfilled && (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, flexWrap: 'wrap' }}>
          <Typography sx={REPORT_FIELD_LABEL_SX}>Motivo:</Typography>
          <Typography sx={REPORT_FIELD_VALUE_SX}>{activity?.comments || '-'}</Typography>
        </Box>
      )}

      <PlanimetryPhotoPanels
        referenceImageUrl={referenceImageUrl}
        downloadName={`${activity?.uid || 'planimetria'}`}
        onOpenReference={() => handleUrlImage(referenceImageUrl)}
        images={imageGallery}
        isReady={isImageGalleryReady}
        hasSourceImages={
          Array.isArray(activity?.planimetry_images) && activity.planimetry_images.length > 0
        }
        filenameForDownloads={filenameForDownloads}
        showImage={showImage}
        currentImageShow={currentImageShow}
        onImageClick={handleImageClick}
        onCloseLightbox={() => handleShowImage(false)}
      />

      {imageUrl && (
        <ImageModal imgSrc={imageUrl} showImage={showImageUrl} setShowImage={setShowImageUrl} />
      )}
    </Box>
  )
}
